const InstagramIcon = () => (
  <img
    className="img--footer_social_icon"
    src={`/svg/IGicon.svg`}
    alt="facebook"
  />
);

export default InstagramIcon;
